//import api from '../../api'

// initial state
import api from "../../api";

const state = {
    current: null,
    random: null,
};

// getters
const getters = {};

// actions
const actions = {
    _getPlan ({ commit }, slug) {
        return new Promise((resolve, reject)=>{
            api
                .get('/plans/'+slug)
                .then(response => {
                    commit('_setPlan', response.data.data);
                    resolve(response.data.data);
                }).catch(error =>{
                    reject(error);
                });
        });
    },
    _getRandom ({ commit }, randomId) {
        return new Promise((resolve, reject)=>{
            api
                .get('/plan/'+randomId)
                .then(response => {
                    commit('_setRandom', response.data.data);
                    resolve(response.data.data);
                }).catch(error =>{
                    reject(error);
                });
        });
    },
};

// mutations
const mutations = {
    _setPlan (state, plan) {
        state.current = plan;
    },
    _setRandom (state, plan) {
        state.random = plan;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
